import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getAppsList } from '../selectors';
import DimensionItemsCell from './DimensionItemsCell';

const AppsCell = ({ key, appsList = [], appSitePublicIds, operator, ...props }) => {
    const formattedAppsList = appsList.map(app => ({
        ...app,
        displayName: app.name,
    }));
    const dimensionApps = formattedAppsList.filter(app =>
        operator === 'in'
            ? app.sites.some(site => appSitePublicIds.find(publicId => site.publicId === publicId))
            : app.sites.every(site => appSitePublicIds.find(publicId => site.publicId === publicId))
    );

    return (
        <DimensionItemsCell
            key={key}
            allItems={formattedAppsList}
            dimensionItems={dimensionApps}
            itemType="APPS"
            operator={operator}
            {...props}
        />
    );
};

AppsCell.propTypes = {
    key: PropTypes.string.isRequired,
    appsList: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
            sites: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.number.isRequired,
                    publicId: PropTypes.string.isRequired,
                    platform: PropTypes.string.isRequired,
                    icon: PropTypes.string.isRequired,
                })
            ),
        })
    ),
    appSitePublicIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    operator: PropTypes.string.isRequired,
};

export default connect(state => ({
    appsList: getAppsList(state),
}))(AppsCell);
